import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { map, Observable } from "rxjs";
import { ZzzConfigService } from "src/app/zzz/core/config/config.service";
import { ReponseActionApi, ReponseActionApiBase } from "src/app/zzz/core/shared/core.models";
import { GrillePagination } from "src/app/zzz/ui/grille/grille.modele";
import {
  ExportUtilisateur,
  ParametrePilotage,
  RechercheStatistique,
  RechercheUtilisateur, ReponseStatistique,
  ReponseUtilisateurs, Statistique, Utilisateur,
  ValeurParametrePilotage
} from "./pilotage.models";


@Injectable({ providedIn: 'root' })
export class PilotageService {
  #http = inject(HttpClient);
  #configService = inject(ZzzConfigService);

  obtenirUtilisateursGrille(dto: RechercheUtilisateur): Observable<GrillePagination<Utilisateur[]>> {
    var baseUrl = this.#configService.get().authApiEndPoint;
    return this.#http.post<ReponseUtilisateurs>(`${baseUrl}/sigtapi/utilisateurs`, dto).pipe(
      map(x => x.listeUtilisateur)
    );
  }

  exportUtilisateurs(dto: ExportUtilisateur): Observable<any> {
    var baseUrl = this.#configService.get().authApiEndPoint;
    return this.#http.post(`${baseUrl}/sigtapi/utilisateurs/export`, dto, { responseType: 'blob' });
  }

  obtenirStatistiquesGrille(dto: RechercheStatistique): Observable<GrillePagination<Statistique[]>> {
    var baseUrl = this.#configService.get().authApiEndPoint;
    return this.#http.post<ReponseStatistique>(`${baseUrl}/sigtapi/journal-evenements/statistiques`, dto).pipe(
      map(x => x.statistiques)
    );
  }

  obtenirParametres(): Observable<ParametrePilotage[]> {
    var baseUrl = this.#configService.get().authApiEndPoint;
    return this.#http.get<ReponseActionApi<ParametrePilotage[]>>(`${baseUrl}/sigtapi/pilotage/parametres`).pipe(
      map(x => x.valeur)
    );
  }

  ajouterValeurParametre(valeur: ValeurParametrePilotage): Observable<ReponseActionApiBase> {
    var baseUrl = this.#configService.get().authApiEndPoint;
    return this.#http.post<ReponseActionApiBase>(`${baseUrl}/sigtapi/pilotage/parametres/valeurs`, { valeur });
  }

  modifierValeurParametre(valeur: ValeurParametrePilotage): Observable<ReponseActionApiBase> {
    var baseUrl = this.#configService.get().authApiEndPoint;
    return this.#http.put<ReponseActionApiBase>(`${baseUrl}/sigtapi/pilotage/parametres/valeurs`, { valeur });
  }
}
